import { GridCellValue } from "@material-ui/data-grid";

const currencyRow = (value: number) => `$${value}`;
const percentageRow = (value: number) => `${value}%`;
const flatRow = (value: number) => value;

export type RowType = "CURRENCY" | "PERCENTAGE" | "FLAT";

export const transformRowValue = (
  value: number | undefined,
  isNotApplicable: boolean,
  isFloat: boolean,
  type: RowType,
) => {
  if (value) {
    const roundedValue = isFloat ? +value?.toFixed(2) : value;
    const validateValue = (valueToValidate: number) =>
      isFloat ? Number.isFinite(valueToValidate) : Number.isInteger(valueToValidate);

    const emptyValue = isNotApplicable ? "N/A" : 0;
    const transformedValue =
      type === "CURRENCY"
        ? currencyRow(roundedValue)
        : type === "PERCENTAGE"
        ? percentageRow(roundedValue)
        : flatRow(roundedValue);

    return validateValue(roundedValue) ? transformedValue : emptyValue;
  }
  return isNotApplicable ? "N/A" : type === "CURRENCY" ? "$0.00" : type === "PERCENTAGE" ? "0.00%" : 0;
};

export const currencySortComparator = (v1: GridCellValue, v2: GridCellValue) => {
  const typedV1 = v1 as string;
  const typedV2 = v2 as string;
  return Number(typedV1.slice(1)) - Number(typedV2.slice(1));
};

export const percentageSortComparator = (v1: GridCellValue, v2: GridCellValue) => {
  const typedV1 = v1 as string;
  const typedV2 = v2 as string;
  return Number.parseInt(typedV1) - Number.parseInt(typedV2);
};

export const flatSortComparator = (v1: GridCellValue, v2: GridCellValue) => {
  const typedV1 = v1 as string;
  const typedV2 = v2 as string;

  return Number.parseInt(typedV1 === "N/A" ? "0" : typedV1) - Number.parseInt(typedV2 === "N/A" ? "0" : typedV2);
};
